// TODO: refatorar isso. muito confuso e zoado
import React, { useCallback, useEffect, useState } from 'react';
import { Card, Form, Col } from 'react-bootstrap';
import { toast } from 'react-toastify';
import styles from '../../../styles.module.css';
import getPacienteById from '../../../services/paciente';
import useConvenios from '../../../hooks/useConvenios';
import useProcedimentos from '../../../hooks/useProcedimentos';

const FORMULARIO_INICIAL = {
  codPaciente: undefined,
  codMedico: undefined,
  nomeMedico: undefined,
  codConvenio: undefined,
  codProcedimento: undefined,
  agendou: undefined,
  marcou: undefined,
  cancelou: undefined,
  agendamento: undefined,
  atendido: undefined,
  codAgenda: undefined,
  situacao: undefined,
  atividade: undefined,
  observacoes: undefined,
  horaAgenda: undefined,
  dataHoraAgenda: undefined,
  dataFormatada: new Date().toISOString().substr(0, 10),
  nomePac: undefined,
  dataAgenda: undefined,
};

const buildFormularioFromAgenda = agendaPac => ({
  dataFormatada: agendaPac.dataFormatada,
  dataAgenda: agendaPac.DATAAGENDA,
  codAgenda: agendaPac.CODAGENDA,
  codPaciente: agendaPac.CODPAC,
  nomePac: agendaPac.NOMEPAC,
  codMedico: agendaPac.CODMED,
  nomeMedico: agendaPac.NOMEMED,
  codConvenio: agendaPac.CODCONV,
  codProcedimento: agendaPac.CODPROCEDI,
  horaAgenda: agendaPac.HORARIO,
  dataHoraAgenda: agendaPac.HORAAGENDA,
  situacao: agendaPac.SITUACAO,
  atividade: agendaPac.ATIVIDADE,
  observacoes: agendaPac.OBSERVACAO,
  agendou: agendaPac.AGENDOU,
  marcou: agendaPac.MARCOU,
  cancelou: agendaPac.CANCELOU,
  agendamento: agendaPac.AGENDAMENTO,
  atendido: agendaPac.ATENDIDO,
});

/**
 * Owns form state so typing does not re-render Agenda siblings.
 * Talks to the parent through domain events / command props.
 */
const AgendaForm = ({
  header,
  onRequestSave,
  onRequestSearchPatients,
  onSelectionChange,
  agendamentoSelecionado,
  camposParaAtualizar,
  onCamposAplicados,
}) => {
  const [formulario, setFormulario] = useState(FORMULARIO_INICIAL);
  const { opcoesConvenio } = useConvenios();
  const { opcoesProcedimento } = useProcedimentos();

  const {
    codPaciente,
    nomePac,
    codMedico,
    nomeMedico,
    codConvenio,
    codProcedimento,
    observacoes,
    dataFormatada,
    horaAgenda,
    situacao,
    atividade,
    agendamento,
    agendou,
    atendido,
    cancelou,
    marcou,
    dataHoraAgenda,
  } = formulario;

  const atualizarCampo = useCallback((campo, valor) => {
    setFormulario(prev => ({
      ...prev,
      [campo]: valor,
    }));
  }, []);

  const handleRequestSave = useCallback(() => {
    onRequestSave?.(formulario);
  }, [onRequestSave, formulario]);

  const handleRequestSearchPatients = useCallback(
    ({ isAgendamento = false } = {}) => {
      onRequestSearchPatients?.(formulario, { isAgendamento });
    },
    [onRequestSearchPatients, formulario]
  );

  useEffect(() => {
    if (!agendamentoSelecionado) return;

    // TODO: aqui ainda preciso melhorar. tá confuso!
    const next = buildFormularioFromAgenda(agendamentoSelecionado.agendamento);
    setFormulario(next);
    onSelectionChange?.({
      codAgenda: next.codAgenda,
      codPaciente: next.codPaciente,
    });

    if (agendamentoSelecionado.opcoes?.focarPaciente) {
      setTimeout(() => {
        const codPacienteInput = document.getElementById('codPaciente');
        if (codPacienteInput) {
          codPacienteInput.focus();
          codPacienteInput.select();
        }
      }, 0);
    }
  }, [agendamentoSelecionado, onSelectionChange]);

  useEffect(() => {
    if (!camposParaAtualizar) return;
    setFormulario(prev => ({ ...prev, ...camposParaAtualizar.campos }));
    onCamposAplicados?.();
  }, [camposParaAtualizar, onCamposAplicados]);

  const handleLocalizarPaciente = async e => {
    e.stopPropagation();
    try {
      const data = await getPacienteById(e.target.value);
      if (data && data.length > 0) {
        atualizarCampo('nomePac', data[0].NOMEPAC);
        const elemConv = document.getElementById('codConvenio');
        if (elemConv) {
          elemConv.focus();
          elemConv.select();
        }
      } else {
        atualizarCampo('nomePac', 'NENHUM PACIENTE ENCONTRADO');
      }
    } catch (err) {
      toast.error(err?.response?.data?.error || 'Erro ao localizar paciente!');
    }
  };

  const handlePacienteKeyUp = e => {
    if (e.key === 'Enter' && codPaciente === 1) {
      e.stopPropagation();
      handleRequestSearchPatients({ isAgendamento: true });
      return;
    }

    if (e.key === 'Enter' && codPaciente > 1) {
      handleLocalizarPaciente(e);
    }
  };

  const handleConvenioKeyUp = e => {
    if (e.key !== 'Enter' || codConvenio === 1000) return;

    const procediElem = document.getElementById('codProcedimento');
    if (!procediElem) return;

    procediElem.focus();
    procediElem.select();
  };

  const handleProcedimentoKeyUp = e => {
    if (e.key !== 'Enter' || codProcedimento === 1000) return;

    const obsElem = document.getElementById('obs');
    if (obsElem) obsElem.focus();
  };

  const handleObservacoesKeyUp = e => {
    if (e.key !== 'Enter') return;

    const horaElem = document.getElementById('horaAgenda');
    if (!horaElem) return;

    horaElem.focus();
    horaElem.select();
  };

  const handleHoraKeyUp = e => {
    if (e.key === 'Enter') handleRequestSave();
  };

  const headerContent = header?.({
    requestSave: handleRequestSave,
    requestSearchPatients: handleRequestSearchPatients,
  });

  return (
    <Card className="mt-2 d-none d-md-block">
      {headerContent ? (
        <Card.Header style={{ backgroundColor: '#d9fbda' }}>
          {headerContent}
        </Card.Header>
      ) : null}
      <Card.Body>
        <Form.Row className="m-0">
          <Form.Group className={styles.labelStyle} size="sm" as={Col} sm={1}>
            Paciente:
          </Form.Group>
          <Form.Group className="m-0" as={Col} controlId="codPaciente">
            <Form.Control
              size="sm"
              type="text"
              className={styles.editStyle}
              aria-label="Código do paciente"
              onKeyUp={handlePacienteKeyUp}
              onChange={e =>
                atualizarCampo('codPaciente', Number(e.target.value))
              }
              value={codPaciente || ''}
            />
          </Form.Group>
          <Form.Group className="m-0" size="sm" as={Col} sm={4}>
            <Form.Control
              className={styles.editStyle}
              size="sm"
              type="text"
              aria-label="Nome do paciente"
              onChange={e => atualizarCampo('nomePac', e.target.value)}
              value={nomePac || ''}
              disabled={codPaciente !== 1}
            />
          </Form.Group>
          <Form.Group className={styles.labelStyle} size="sm" as={Col} sm={1}>
            Médico:
          </Form.Group>
          <Form.Group className="m-0" as={Col} sm={1}>
            <Form.Control
              size="sm"
              className={styles.editStyle}
              aria-label="Código do médico"
              onChange={e =>
                atualizarCampo('codMedico', Number(e.target.value))
              }
              value={codMedico || ''}
            />
          </Form.Group>
          <Form.Group className="m-0" as={Col} sm={4}>
            <Form.Control
              className={styles.editStyle}
              size="sm"
              aria-label="Nome do médico"
              onChange={e => atualizarCampo('nomeMedico', e.target.value)}
              value={nomeMedico || ''}
            />
          </Form.Group>
        </Form.Row>
        <Form.Row className="m-0">
          <Form.Group className={styles.labelStyle} size="sm" as={Col} sm={1}>
            Convênio:
          </Form.Group>
          <Form.Group controlId="codConvenio" className="m-0" as={Col} sm={1}>
            <Form.Control
              className={`m-0 ${styles.editStyle}`}
              size="sm"
              aria-label="Código do convênio"
              onChange={e =>
                atualizarCampo('codConvenio', Number(e.target.value))
              }
              value={codConvenio || ''}
              onKeyUp={handleConvenioKeyUp}
            />
          </Form.Group>
          <Form.Group as={Col} className="m-0">
            <Form.Control
              as="select"
              size="sm"
              className={styles.editStyle}
              aria-label="Convênio"
              onChange={e =>
                atualizarCampo('codConvenio', Number(e.target.value))
              }
              value={codConvenio || ''}
            >
              <option value="" disabled>
                Selecione o Convênio
              </option>
              {opcoesConvenio.map(option => (
                <option key={option.value} value={option.value}>
                  {option.label}
                </option>
              ))}
            </Form.Control>
          </Form.Group>
          <Form.Group className={styles.labelStyle} size="sm" as={Col} sm={1}>
            Procedi:
          </Form.Group>
          <Form.Group
            controlId="codProcedimento"
            className="m-0"
            as={Col}
            sm={1}
          >
            <Form.Control
              className={`m-0 ${styles.editStyle}`}
              size="sm"
              aria-label="Código do procedimento"
              onChange={e =>
                atualizarCampo('codProcedimento', Number(e.target.value))
              }
              value={codProcedimento || ''}
              onKeyUp={handleProcedimentoKeyUp}
            />
          </Form.Group>
          <Form.Group className="m-0" as={Col} sm={4}>
            <Form.Control
              as="select"
              size="sm"
              className={styles.editStyle}
              aria-label="Procedimento"
              onChange={e =>
                atualizarCampo('codProcedimento', Number(e.target.value))
              }
              value={codProcedimento || ''}
            >
              <option value="" disabled>
                Selecione o Procedimento
              </option>
              {opcoesProcedimento.map(option => (
                <option key={option.value} value={option.value}>
                  {option.label}
                </option>
              ))}
            </Form.Control>
          </Form.Group>
        </Form.Row>
        <Form.Row className="m-0" id="obs-row">
          <Form.Group size="sm" className={styles.labelStyle} as={Col} sm={1}>
            Observ:
          </Form.Group>
          <Form.Group controlId="obs" className="m-0" as={Col} sm>
            <Form.Control
              size="sm"
              as="textarea"
              rows="2"
              className={styles.editStyle}
              style={{ textTransform: 'none' }}
              aria-label="Observações"
              onChange={e => atualizarCampo('observacoes', e.target.value)}
              value={observacoes || ''}
              onKeyDown={e => {
                if (e.key === 'Enter') e.preventDefault();
              }}
              onKeyUp={handleObservacoesKeyUp}
            />
          </Form.Group>
        </Form.Row>

        <Form.Row className="m-0">
          <Form.Group
            className={`m-0 ${styles.labelStyle}`}
            size="sm"
            as={Col}
            sm={1}
          >
            Data:
          </Form.Group>
          <Form.Group className="m-0" as={Col} sm={3}>
            <Form.Control
              readOnly={true}
              className={styles.editStyle}
              size="sm"
              aria-label="Data da agenda"
              value={dataFormatada}
            />
          </Form.Group>
          <Form.Group
            className={`m-0 ${styles.labelStyle}`}
            size="sm"
            as={Col}
            sm={1}
          >
            Hora:
          </Form.Group>
          <Form.Group controlId="horaAgenda" className="m-0" as={Col} sm={1}>
            <Form.Control
              size="sm"
              className={`m-0 ${styles.editStyle}`}
              style={{
                backgroundColor: '#94fa94',
                color: '#000000',
              }}
              aria-label="Hora da agenda"
              onChange={e =>
                atualizarCampo('horaAgenda', Number(e.target.value))
              }
              value={horaAgenda || ''}
              onKeyUp={handleHoraKeyUp}
            />
          </Form.Group>
          <Form.Group
            className={`${styles.labelStyle}`}
            size="sm"
            as={Col}
            sm={1}
          >
            Situação:
          </Form.Group>
          <Form.Group className="m-0" as={Col} sm={2}>
            <Form.Control
              size="sm"
              readOnly={true}
              className={styles.editStyle}
              aria-label="Situação"
              value={situacao || ''}
            />
          </Form.Group>
          <Form.Group className={styles.labelStyle} size="sm" as={Col} sm={1}>
            Atividade:
          </Form.Group>
          <Form.Group className="m-0" as={Col} sm={2}>
            <Form.Control
              size="sm"
              className={styles.editStyle}
              aria-label="Atividade"
              value={atividade || ''}
            />
          </Form.Group>
        </Form.Row>
        <Form.Row className="m-0">
          <Form.Group className={styles.labelStyle} size="sm" as={Col} sm={1}>
            Agenda:
          </Form.Group>
          <Form.Group className="m-0" as={Col} sm={1}>
            <Form.Control
              size="sm"
              readOnly={true}
              className={styles.editStyle}
              aria-label="Quem agendou"
              value={agendamento || ''}
            />
          </Form.Group>
          <Form.Group className={styles.labelStyle} size="sm" as={Col} sm={1}>
            Marcou:
          </Form.Group>
          <Form.Group className="m-0" as={Col} sm={1}>
            <Form.Control
              size="sm"
              readOnly={true}
              className={styles.editStyle}
              aria-label="Quem marcou"
              value={agendou || ''}
            />
          </Form.Group>
          <Form.Group className={styles.labelStyle} size="sm" as={Col} sm={1}>
            Atendido:
          </Form.Group>
          <Form.Group className="m-0" as={Col} sm={1}>
            <Form.Control
              size="sm"
              readOnly={true}
              className={styles.editStyle}
              aria-label="Atendido"
              value={atendido || ''}
            />
          </Form.Group>
          <Form.Group className={styles.labelStyle} size="sm" as={Col} sm={1}>
            Cancelou:
          </Form.Group>
          <Form.Group className="m-0" as={Col} sm={1}>
            <Form.Control
              size="sm"
              readOnly={true}
              className={styles.editStyle}
              aria-label="Quem cancelou"
              value={cancelou || ''}
            />
          </Form.Group>
          <Form.Group className={styles.labelStyle} size="sm" as={Col} sm={1}>
            Altera:
          </Form.Group>
          <Form.Group className="m-0" as={Col} sm={1}>
            <Form.Control
              size="sm"
              readOnly={true}
              className={styles.editStyle}
              aria-label="Quem alterou"
              value={marcou || ''}
            />
          </Form.Group>
          <Form.Group className="m-0" as={Col} sm={2}>
            <Form.Control
              size="sm"
              readOnly={true}
              className={styles.editStyle}
              aria-label="Data e hora da agenda"
              value={dataHoraAgenda || ''}
            />
          </Form.Group>
        </Form.Row>
      </Card.Body>
    </Card>
  );
};

export default AgendaForm;
